"use strict";
// @ts-ignore
try {
    self['workbox:core:5.1.3'] && _();
}
catch (e) { }
